import { createForm, useCreateFormStore } from '@components/form';
import { hideModal, Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useUpdateJourneyWebhook } from 'api/journey-webhooks/hooks';
import { JourneyWebhook } from 'api/journey-webhooks/requests';

export const useWebhookSampleData = () => useModal(WebhookSampleData, { variant: 'LARGE' });

type WebhookSampleDataeData = {
  payloadVariables: string;
  headerVariables: string;
};

const Form = createForm<WebhookSampleDataeData>();

export const WebhookSampleData = ({ webhook }: { webhook: JourneyWebhook }) => {
  const { t } = useScopedTranslate(locale);
  const updateMutation = useUpdateJourneyWebhook(webhook);

  const formStore = useCreateFormStore();

  const handleSubmit = (data: WebhookSampleDataeData) => {
    updateMutation.mutate(data, {
      onSuccess: hideModal,
    });
  };

  return (
    <Modal>
      <Form store={formStore} onSubmit={handleSubmit}>
        <Modal.SimpleHeader title={t('title')} />
        <Modal.Content>
          <Stack space={6}>
            <Text text={t('description')} />
            <Stack space={4}>
              <Form.JsonEditor id="payloadVariables" label={t('addPayload')} isRequired />
              <Form.JsonEditor id="headerVariables" label={t('headers')} />
            </Stack>
          </Stack>
        </Modal.Content>
        <Modal.Footer>
          <Form.Actions>
            <Form.Reset text={t('core.cancel')} variant="secondary" onClick={hideModal} />
            <Form.Submit text={t('addPayload')} variant="primary-blue" />
          </Form.Actions>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const locale = {
  en: {
    title: 'Populate from sample data',
    description:
      "Paste a sample webhook response below. We'll analyze the structure and automatically configure the fields",
    samplePayload: 'Sample payload',
    headers: 'Headers',
    addPayload: 'Add payload',
  },
};
